export const manager = {
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'online manager',
      pt3: 'om zelf de regie in handen te houden'
    },
    description: 'Met de Bistroo Manager-app pas je alles in jouw webshop in slechts enkele seconden aan. Verwerk elke bestelling moeiteloos en blijf altijd de chef in jouw online restaurant.',
    button: 'Ontdek de Manager'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Realtime controle over jouw online shop',
      text: 'Houd de perfecte klantervaring in stand. Pas al je instellingen in realtime aan via de Bistroo Manager. Toegankelijk op al je apparaten, vanaf iedere locatie.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_2: {
      title: 'Perfecte bezorginstellingen',
      text: 'Stem je bezorggebieden perfect af op je capaciteiten van de dag en teken je gewenste gebieden haarscherp op Google Maps. Met de mogelijkheid om je voorwaarden per bezorggebied aan te passen.',
      cta: ''
    },
    paragraph_3: {
      title: 'Inzichten & Rapportages',
      text: 'Geavanceerde inzichten en rapportages zijn beschikbaar via de Manager-app. Pas je voorwaarden aan op basis van datagedreven beslissingen en suggesties van de Manager.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_4: {
      title: 'Stroomlijn jouw processen',
      text: 'Bespaar kostbare tijd en handmatig werk, zonder ooit verrast te worden door te veel bestellingen of onverwacht online verkeer! Pas eenvoudig je piektijd-volume en geschatte levertijden aan met één druk op de knop. Blijf ten alle tijden in controle.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Pas je menu en instellingen eenvoudig aan.',
        text: 'Pas het menu en instellingen van jouw restaurant aan vanaf iedere locatie. Krijg toegang vanaf ieder apparaat, op elk moment en wijzig eenvoudig producten, prijzen, voorraad, kortingen, promoties en bezorggebieden. ',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel jouw favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Beheer meerdere locaties.',
        text: 'Beheer eenvoudig meerdere locaties, indien van toepassing op jouw onderneming.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Volg jouw betalingen.',
        text: 'Of verwerk terugbetalingen. Het gemiddelde terugbetalingspercentage bedraagt echter slechts 0,2%.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Rapportages & Analyses.',
        text: 'Analyseer je online prestaties met basis- en geavanceerde rapportage opties.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"De Manager wordt telkens vernieuwd, leuk om de ontwikkelingen te zien en mee te maken "',
    cta: 'Lees volledig verhaal',
    name: 'Istanbul Grillroom',
    job_title: 'Grillroom'
  }
}